export interface ReferenceVerificationAnswers {
  relationship_summary?: string;
  strengths?: string;
  concerns?: string;
  worked_together?: boolean;
  recommend_hire?: boolean;
}

export function parseReferenceVerificationAnswers(
  raw: unknown
): ReferenceVerificationAnswers | null {
  if (!raw) return null;
  if (typeof raw === 'string') {
    try {
      return JSON.parse(raw) as ReferenceVerificationAnswers;
    } catch {
      return null;
    }
  }
  if (typeof raw === 'object') {
    return raw as ReferenceVerificationAnswers;
  }
  return null;
}

export function getReferenceFeedbackSummary(answers: ReferenceVerificationAnswers | null): string {
  if (!answers) return '';
  const parts: string[] = [];
  if (answers.strengths?.trim()) {
    parts.push(answers.strengths.trim());
  }
  if (answers.relationship_summary?.trim() && parts.length === 0) {
    parts.push(answers.relationship_summary.trim());
  }
  return parts.join(' ').slice(0, 220);
}
